// ignore-string-externalization
import styled from 'styled-components';
import { Type, screenSmMax, cta2FontSize } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, withAnimationContext } from './Animations';
export var StyledSupertext = styled(Type.h6).attrs({
  variant: 'body1',
  weight: Type.book
}).withConfig({
  displayName: "Supertext__StyledSupertext",
  componentId: "sc-79gmz7-0"
})(["", ";text-align:", ";text-transform:uppercase;padding-bottom:0px;@media (max-width:", "){font-size:", ";}"], fadeInAnimation(DELAYS.FIRST), function (_ref) {
  var centered = _ref.centered;
  return centered ? 'center' : 'left';
}, screenSmMax, cta2FontSize);
export var Supertext = withAnimationContext(StyledSupertext);